import React, { useEffect } from "react";

/**
 * Works like `useMemo`, but for asynchronous operations.
 * It will execute the callback function and return the result once the promise resolves.
 * The result will be memoized based on the dependencies provided.
 * If the dependencies change, the callback will be executed again.
 * @param callback the asynchronous function to execute
 * @param deps the dependencies that trigger the callback execution
 * @param initialValue the initial value to return before the promise resolves
 * @returns the resolved value of the promise or the initialValue if the promise is still pending
 */
export function useMemoAsync<T>(
  callback: () => Promise<T>,
  deps: any[],
  initialValue?: T
): T | undefined {
  const [value, setValue] = React.useState<T | undefined>(initialValue);

  useEffect(() => {
    callback().then(setValue);
  }, [...deps]);

  return value;
}
